export default "__VITE_ASSET__BbfLTxRG__"